import { render } from "./locationList.vue?vue&type=template&id=4dd8d2a6"
import script from "./locationList.vue?vue&type=script&lang=js"
export * from "./locationList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__